import injectSheet from 'react-jss';

import LeftYAxis from './component';
import styles from './styles';

export default injectSheet(styles)(LeftYAxis);
